import { ProfileScreen } from '@/components/profile/profile-screen';

export default function ProfilePage() {
  return <ProfileScreen />;
}
